<template>
    <div class="home">
        <Slider />


        <section class="p-8">
            <div class="max-w-4xl mx-auto">
                <!-- Title with Underline -->
                <h2 class="text-xl font-bold text-gray-800 uppercase mb-2">Contact Us</h2>
                <div class="border-b-2 border-purple w-28 mb-4"></div>

                <!-- Subtitle -->
                <h3 class="text-2xl font-semibold text-black mb-4">Drop us a line</h3>

                <!-- Description Text -->
                <p class="text-gray-700 leading-relaxed mb-4">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor lorem ipsum dolor sit
                    amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel
                    facilisis. Ut labore et dolore magna aliqua.
                </p>

                <!-- Additional Text -->
                <p class="text-gray-700 leading-relaxed">
                    Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel
                    facilisis. Ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing
                    elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </p>
            </div>
        </section>


        <section class="bg-purple p-10 rounded-lg max-w-4xl mx-auto mb-10">
            <div class="max-w-6xl mx-auto grid grid-cols-2 gap-8">
                <div class="text-white">
                    <h3 class="text-xl font-bold mb-4">Support & Questions</h3>
                    <p>Email: Lorem ipsum</p>
                    <p>Telephone: 2323 232 23</p>
                    <p class="mb-8">Address: Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas
                        accumsan lacus vel facilisis.</p>

                    <div class="mb-4">
                        <p class="font-semibold">Lorem Ipsum Dolor Sit</p>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.</p>
                    </div>
                    <div class="mb-4">
                        <p class="font-semibold">Lorem Ipsum Dolor Sit</p>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.</p>
                    </div>
                    <div class="mb-8">
                        <p class="font-semibold">Lorem Ipsum Dolor Sit</p>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.</p>
                    </div>

                    <!-- Social Media Icons -->
                    <div class="flex space-x-4 w-3/5 justify-center py-2" style="background-color: #E8D0EA;">
                        <a href="#" class="bg-purple p-2 flex items-center text-white">
                            <i class="fab fa-facebook-f"></i>
                        </a>
                        <a href="#" class="bg-purple p-2 flex items-center text-white">
                            <i class="fab fa-instagram"></i>
                        </a>
                        <a href="#" class="bg-purple p-2 flex items-center text-white">
                            <i class="fab fa-linkedin-in"></i>
                        </a>
                        <a href="#" class="bg-purple p-2 flex items-center text-white">
                            <i class="fab fa-envelope"></i>
                        </a>
                    </div>
                </div>

                <!-- Right Column: Form -->
                <div class="p-8 rounded-lg" style="background-color: #E8D0EA;">
                    <img src="@/assets/images/logo.png" alt="">
                    <p class="text-purple-700 mb-6">Please enter your details (it only takes 30 seconds) and we will get
                        in touch with you shortly.</p>

                    <form>
                        <div class="mb-4">
                            <label class="block text-purple mb-1" for="first-name">First Name *</label>
                            <input type="text" id="first-name"
                                class="w-full border-b-2 border-purple bg-transparent focus:outline-none focus:border-purple-700">
                        </div>
                        <div class="mb-4">
                            <label class="block text-purple mb-1" for="last-name">Last Name *</label>
                            <input type="text" id="last-name"
                                class="w-full border-b-2 border-purple bg-transparent focus:outline-none focus:border-purple-700">
                        </div>
                        <div class="mb-6">
                            <label class="block text-purple mb-1" for="email">Email *</label>
                            <input type="email" id="email"
                                class="w-full border-b-2 border-purple bg-transparent focus:outline-none focus:border-purple-700">
                        </div>
                        <button type="submit" class="bg-purple text-white px-6 py-2 rounded-full">Submit</button>
                    </form>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import Slider from '@/components/Slider.vue';
export default {
    name: 'ContactUs',
    components: {
        Slider,
    },

}
</script>